import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

import theme from '@themes/default';

export const VoucherDiscountInfoWrapper = styled.div<{
  newDesign: boolean;
  isUnderSelectBox?: boolean;
}>`
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.palette.primary}08;
  padding: 0.75rem;
  margin: ${(props) =>
    props.isUnderSelectBox ? '0 0 0.75rem 0' : '-1rem 0 0.75rem 0'};

  ${({ newDesign }) =>
    newDesign
      ? css`
          @media (min-width: ${breakpoints.md}) {
            margin: 0.5rem 0 0.75rem 0;
          }
        `
      : css`
          margin: -1rem 0 0.75rem 0;

          @media (min-width: ${breakpoints.md}) {
            margin: -1.15rem 0 0.75rem 0;
          }
        `}
`;

export const DiscountInfoDescription = styled.div`
  text-align: left;
`;

export const DiscountAmmountWrapper = styled.span<{
  newDesign: boolean;
  color?: string;
}>`
  color: ${({ color = theme.palette.primary }) => color};

  ${({ newDesign }) =>
    newDesign
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
        `}
`;

export const CodeWrapper = styled.span<{ newDesign: boolean }>`
  text-transfrom: uppercase;
  color: ${theme.palette.basic};

  ${({ newDesign }) =>
    newDesign
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
        `}
`;

export const TermsWrapper = styled.div<{
  newDesign: boolean;
}>`
  font-size: 0.75rem;
  color: ${theme.palette.neutralDark};
  font-weight: normal;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  @media (min-width: ${breakpoints.sm}) {
    align-items: center;
  }

  ${({ newDesign }) =>
    !newDesign &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        margin-top: 0.2rem;
      }
    `}
`;

export const TextWrapper = styled.div<{ newDesign: boolean }>`
  margin-bottom: 0.25rem;
  color: ${theme.palette.basic};

  ${({ newDesign }) =>
    newDesign
      ? theme.typography.labelRegular400
      : css`
          ${theme.typography.labelLarge}
          font-weight: 500;
        `}
`;

export const VoucherDiscountIconWrapper = styled.div<{
  hideDesktop: boolean;
}>`
  height: 2.25rem;
  display: block;

  margin: 0 0 0 2rem;

  @media (min-width: ${breakpoints.sm}) {
    display: ${({ hideDesktop }) => (hideDesktop ? 'none' : 'block')};
    margin: 0 0 0 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0 2.5rem;
  }
`;

export const InfoIconWrapper = styled.span<{ newDesign: boolean }>`
  display: flex;
  align-items: center;
  margin-top: 0.1rem;

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const InstructionTextWrapper = styled.span<{ newDesign: boolean }>`
  padding-right: 0.3rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          ${theme.typography.labelSmall400}
          color: ${theme.palette.neutralDarker}
        `
      : css`
          ${theme.typography.labelRegular400}
        `}
`;
